export const GLUEUP_LOGO_URL =
  "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://glueup.com&size=64";
